var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.879,
    height: 10.698,
    viewBox: "0 0 10.879 10.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.816 54.167a.816.816 0 1 0 .816.816.817.817 0 0 0-.816-.816zm0 1.269a.453.453 0 1 1 .453-.453.454.454 0 0 1-.453.453z",
    transform: "translate(-48.912 -48.912)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.885 5.618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.16 5.618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(9.248 6.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.522 6.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.434 5.618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.797 6.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(6.709 5.618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.072 6.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(5.984 5.618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(6.346 6.162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.879 7.139V5a.836.836 0 0 0-.836-.836H.836A.836.836 0 0 0 0 5v2.139a.831.831 0 0 0 .322.654.832.832 0 0 0-.322.655v2.137a.831.831 0 0 0 .322.654.831.831 0 0 0-.322.654v2.137a.836.836 0 0 0 .836.836h9.208a.836.836 0 0 0 .836-.836v-2.137a.831.831 0 0 0-.322-.654.831.831 0 0 0 .322-.654V8.448a.831.831 0 0 0-.322-.654.831.831 0 0 0 .321-.655zm-.363 4.754v2.137a.473.473 0 0 1-.473.473H.836a.473.473 0 0 1-.473-.473v-2.137a.473.473 0 0 1 .473-.473h9.208a.473.473 0 0 1 .473.473zm0-3.445v2.137a.473.473 0 0 1-.473.473H.836a.473.473 0 0 1-.473-.473V8.448a.473.473 0 0 1 .473-.473h9.208a.473.473 0 0 1 .473.473zm-9.68-.836a.473.473 0 0 1-.473-.473V5a.473.473 0 0 1 .473-.47h9.208a.473.473 0 0 1 .473.47v2.139a.473.473 0 0 1-.473.473H.836z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.816 214.132a.816.816 0 1 0-.816-.816.817.817 0 0 0 .816.816zm0-1.269a.453.453 0 1 1-.453.453.454.454 0 0 1 .453-.453z",
    transform: "translate(-48.912 -203.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.885 9.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.16 9.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(9.248 9.607)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.522 9.607)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.434 9.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.797 9.607)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(6.709 9.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.072 9.607)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(5.984 9.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(6.346 9.607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.816 372.465a.816.816 0 1 0-.816-.816.817.817 0 0 0 .816.816zm0-1.269a.453.453 0 1 1-.453.453.454.454 0 0 1 .453-.449z",
    transform: "translate(-48.912 -358.688)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.885 12.508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.16 12.508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(9.248 13.052)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(8.522 13.052)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.434 12.508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.797 13.052)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(6.709 12.508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(7.072 13.052)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(5.984 12.508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.181,
    cy: 0.181,
    r: 0.181,
    transform: "translate(6.346 13.052)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.8a20e5abdf14d7cfcc50a843d96e5017.svg";
export { ForwardRef as ReactComponent };